export default __webpack_public_path__ + "static/media/emoji.d6543ae5.jpg";